import { render, staticRenderFns } from "./AddRoleDialogEx.vue?vue&type=template&id=3a251052&"
import script from "./AddRoleDialogEx.vue?vue&type=script&lang=js&"
export * from "./AddRoleDialogEx.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleDialogEx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports